export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    
  },
  {
    path: "/404",
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  {
    path: "/home",
    name: "Home",
    component: () =>
    import(/* webpackChunkName: "home" */ "../views/Home.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contacto.vue"),
  },
  {
    path: "/blog",
    name: "Blog",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "blog" */ "../views/Blog.vue"),
  },
  {
    path: "/blog/articulo/:id",
    name: "Articulo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/Post.vue"),
  },
  {
    path: "/admin/articulo-panel",
    name: "ArticuloPanel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/PostManager.vue"),
  },
  {
    path: "/admin/categorias-panel",
    name: "CategoriasPanel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/CategoryManager.vue"),
  },
  {
    path: "/admin/footer-panel",
    name: "FooterPanel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/FooterManager.vue"),
  },
  {
    path: "/admin/politicas-panel",
    name: "PoliticasPanel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/PoliticsManager.vue"),
  },
  {
    path: "/admin/planes-panel",
    name: "PlanesPanel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/PlanesManager.vue"),
  },
  {
    path: "/aviso",
    name: "Aviso",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "notice" */ "../views/Aviso.vue"),
  },
  {
    path: "/admin/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "notice" */ "../views/Login.vue"),
  },
  {
    path: "/presentacion",
    name: "Presentacion",
    component: () =>
    import(/* webpackChunkName: "home" */ "../views/Presentacion.vue"),
  },
  ];
